import { render, staticRenderFns } from "./CardNew.vue?vue&type=template&id=945eec24"
import script from "./CardNew.vue?vue&type=script&lang=js"
export * from "./CardNew.vue?vue&type=script&lang=js"
import style0 from "./CardNew.vue?vue&type=style&index=0&id=945eec24&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports